/**
 * Same locale rules as SamAgain Frontend getInitialLocale / shouldAskLocalePreference.
 * Redirects to a published Shopify language URL when possible; always syncs i18n_locale.
 */
(function (global) {
  var UI_LOCALE_KEY = "i18n_locale";
  var LOCALE_ASKED_KEY = "i18n_locale_asked";
  var DEFAULT_LOCALE = "de";
  var STANDARD = { de: 1, en: 1, fr: 1, es: 1, it: 1, nl: 1, da: 1 };
  var SWISS = {
    ch: 1,
    "ch-zh": 1,
    "ch-be": 1,
    "ch-bs": 1,
    "ch-sg": 1,
    "ch-lu": 1,
    "ch-gr": 1,
  };
  var GERMANY_TZ = { "Europe/Berlin": 1, "Europe/Busingen": 1 };
  var FRANCE_TZ = { "Europe/Paris": 1 };

  function cfg() {
    return global.__SA_LOCALE__ || { current: "de", languages: [] };
  }

  function storage() {
    try {
      return global.localStorage;
    } catch (e) {
      return null;
    }
  }

  function timeZone() {
    try {
      return global.Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {
      return null;
    }
  }

  function isLikelyGermany(tz) {
    return !!GERMANY_TZ[tz || timeZone()];
  }

  function isLikelyFrance(tz) {
    return !!FRANCE_TZ[tz || timeZone()];
  }

  function resolveSwiss(locale) {
    if (locale === "ch") return "ch-zh";
    if (locale === "ch-vs" || locale === "ch-ag") return "de";
    return locale;
  }

  function primary(code) {
    return String(code || "")
      .split("-")[0]
      .toLowerCase();
  }

  function isSupported(code) {
    return !!STANDARD[code] || !!SWISS[code];
  }

  function getStored() {
    try {
      var s = storage();
      if (!s) return null;
      var stored = s.getItem(UI_LOCALE_KEY);
      if (!stored) return null;
      var resolved = resolveSwiss(stored);
      return isSupported(resolved) ? resolved : null;
    } catch (e) {
      return null;
    }
  }

  function persist(code, force) {
    if (!code) return;
    var resolved = resolveSwiss(String(code).trim());
    if (!isSupported(resolved)) return;
    try {
      var s = storage();
      if (!s) return;
      var stored = s.getItem(UI_LOCALE_KEY);
      if (!force && resolved === "de" && stored && SWISS[stored]) return;
      s.setItem(UI_LOCALE_KEY, resolved);
    } catch (e) {}
  }

  function markAsked() {
    try {
      var s = storage();
      if (s) s.setItem(LOCALE_ASKED_KEY, "1");
    } catch (e) {}
  }

  function forceAskFromUrl() {
    try {
      return new URLSearchParams(global.location.search).get("askLocale") === "1";
    } catch (e) {
      return false;
    }
  }

  function shouldAsk() {
    if (forceAskFromUrl()) return true;
    try {
      var s = storage();
      if (s && s.getItem(LOCALE_ASKED_KEY)) return false;
    } catch (e) {
      return false;
    }
    if (isLikelyGermany() || isLikelyFrance()) return false;
    return true;
  }

  /** App getInitialLocale */
  function getInitialLocale() {
    try {
      var stored = getStored();
      if (stored) return stored;

      if (isLikelyFrance()) return "fr";

      var nav = global.navigator || {};
      var tags =
        nav.languages && nav.languages.length
          ? nav.languages
          : nav.language
            ? [nav.language]
            : [];
      for (var i = 0; i < tags.length; i++) {
        var tag = tags[i];
        if (typeof tag !== "string") continue;
        var p = primary(tag);
        if (p && isSupported(p)) return p;
      }
      return DEFAULT_LOCALE;
    } catch (e) {
      return DEFAULT_LOCALE;
    }
  }

  /** Locale used for Shopify storefront URLs (swiss → de). */
  function shopifyLocale(appLocale) {
    if (SWISS[appLocale] || appLocale === "ch") return "de";
    return primary(appLocale) || DEFAULT_LOCALE;
  }

  function publishedMap() {
    var map = {};
    var list = cfg().languages || [];
    for (var i = 0; i < list.length; i++) {
      var lang = list[i];
      if (!lang || !lang.code) continue;
      map[String(lang.code).toLowerCase()] = lang;
    }
    return map;
  }

  function stripLocalePrefix(pathname, map) {
    var path = pathname || "/";
    var roots = [];
    for (var code in map) {
      if (!Object.prototype.hasOwnProperty.call(map, code)) continue;
      var root = map[code].root || "/";
      if (root && root !== "/") roots.push(root.replace(/\/$/, ""));
    }
    roots.sort(function (a, b) {
      return b.length - a.length;
    });
    for (var i = 0; i < roots.length; i++) {
      var prefix = roots[i];
      if (path === prefix) return "/";
      if (path.indexOf(prefix + "/") === 0) return path.slice(prefix.length) || "/";
    }
    return path;
  }

  function urlForLocale(code, map) {
    var lang = map[code];
    if (!lang) return null;
    var root = lang.root || "/";
    var stripped = stripLocalePrefix(global.location.pathname, map);
    var search = global.location.search || "";
    var hash = global.location.hash || "";
    if (root === "/" || root === "") {
      return stripped + search + hash;
    }
    var base = root.replace(/\/$/, "");
    if (stripped === "/") return base + search + hash;
    return base + stripped + search + hash;
  }

  function runRedirect() {
    var map = publishedMap();
    var current = String(cfg().current || "de").toLowerCase();
    var desiredApp = getInitialLocale();
    var desiredShop = shopifyLocale(desiredApp);

    persist(desiredApp);

    if (shouldAsk()) return { asked: true, desiredApp: desiredApp };

    if (!map[desiredShop]) return { asked: false, desiredApp: desiredApp };

    if (desiredShop === current) return { asked: false, desiredApp: desiredApp };

    var next = urlForLocale(desiredShop, map);
    var here = global.location.pathname + (global.location.search || "") + (global.location.hash || "");
    if (!next || next === here) {
      return { asked: false, desiredApp: desiredApp };
    }
    global.location.replace(next);
    return { redirected: true, desiredApp: desiredApp };
  }

  function bindSwitcher() {
    global.document.addEventListener(
      "click",
      function (event) {
        var link =
          event.target.closest &&
          event.target.closest("localization-form a[hreflang][data-value]");
        if (!link) return;
        persist(link.getAttribute("data-value"), true);
        markAsked();
      },
      true
    );

    if (!cfg().primary) {
      persist(cfg().current);
    }
  }

  function runAskUi() {
    if (!shouldAsk()) return;
    var map = publishedMap();
    var codes = Object.keys(map);
    if (codes.length <= 1) {
      markAsked();
      return;
    }

    var root = global.document.getElementById("sa-locale-ask");
    if (!root) return;
    root.hidden = false;
    root.setAttribute("aria-hidden", "false");

    var list = root.querySelector("[data-sa-locale-ask-list]");
    if (!list || list.getAttribute("data-ready") === "1") return;
    list.setAttribute("data-ready", "1");

    var detected = shopifyLocale(getInitialLocale());
    codes.sort(function (a, b) {
      if (a === detected) return -1;
      if (b === detected) return 1;
      return a.localeCompare(b);
    });

    codes.forEach(function (code) {
      var lang = map[code];
      var btn = global.document.createElement("button");
      btn.type = "button";
      btn.className = "sa-locale-ask__btn";
      btn.textContent = lang.name || code;
      if (code === detected) btn.className += " sa-locale-ask__btn--active";
      btn.addEventListener("click", function () {
        persist(code, true);
        markAsked();
        var next = urlForLocale(code, map);
        if (next && code !== String(cfg().current || "").toLowerCase()) {
          global.location.assign(next);
        } else {
          root.hidden = true;
          root.setAttribute("aria-hidden", "true");
        }
      });
      list.appendChild(btn);
    });
  }

  global.SaLocaleDetect = {
    runRedirect: runRedirect,
    runAskUi: runAskUi,
    bindSwitcher: bindSwitcher,
    getInitialLocale: getInitialLocale,
    shouldAsk: shouldAsk,
  };
})(window);
